export default [
  {
    path: '/mantenedor/templates',
    name: 'mantenedor-templates',
    component: () => import(/* webpackChunkName: "mantenedor-templates" */ '@/pages/mantenedor/templates/ManageEmailTemplatesPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mantenedor/templates/:templateKey',
    name: 'mantenedor-template-detail',
    component: () => import(/* webpackChunkName: "mantenedor-template-detail" */ '@/pages/mantenedor/templates/ManageEmailTemplateDetailPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mantenedor/filtros-correo',
    name: 'mantenedor-mail-filtros',
    component: () => import(/* webpackChunkName: "mantenedor-mail-filtros" */ '@/pages/mantenedor/mail-filtros/MailFiltrosPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mantenedor/ns-mx',
    name: 'mantenedor-ns-mx',
    component: () => import(/* webpackChunkName: "mantenedor-ns-mx" */ '@/pages/mantenedor/ns-mx/NsMxDominiosPage.vue'),
    meta: { requiresAuth: true }
  }
]
